import React from 'react';

import {Container} from './styles';

export function Modal({business,setSearch, setIdBusiness,handleInputBlur,page,action}){

    return(
        <Container>
           {business.map((item) => {
               return(
                   <div 
                        key={item.idBusiness}
                        onClick={() => {
                            setSearch(item.name)
                            setIdBusiness(item.idBusiness)
                            handleInputBlur()
                        }}
                   >
                       <p>{item.name}</p>
                   </div>
               )
           })}

           {
               page != null &&
               <div className="button-container">
                   <button onClick={action}>Ver Mais</button>
               </div>
           }
        </Container>
    )
}